import React, { useState } from 'react';
import SocialAuthButtons from '../components/SocialAuthButtons';

/*
  LoginPage — login form extracted from App.js.
  Props: navigateTo, setUser, setIsLoggedIn
*/
const LoginPage = ({ navigateTo, setUser, setIsLoggedIn, notice }) => {
  const [loginData, setLoginData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!loginData.email || !loginData.password) {
      setError('Please fill in all fields');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(loginData),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Login failed');

      setUser(data.user);
      setIsLoggedIn(true);
      setLoginData({ email: '', password: '' });
      if (data.user.isFirstLogin) {
        navigateTo('welcome');
      } else {
        navigateTo(data.user.accountType === 'personal' ? 'personal-dashboard' : 'dashboard');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  const btnPrimary = {
    backgroundColor: 'var(--accent)',
    color: '#ffffff', border: 'none', borderRadius: '9px', fontWeight: 700,
    cursor: 'pointer', transition: 'background-color 0.2s ease',
    fontFamily: 'inherit',
  };
  const btnPrimaryHover = (e) => {
    e.currentTarget.style.backgroundColor = 'var(--accent-hover)';
  };
  const btnPrimaryLeave = (e) => {
    e.currentTarget.style.backgroundColor = 'var(--accent)';
  };
  const inputStyle = {
    width: '100%', padding: '12px 16px', borderRadius: '10px',
    border: '1px solid var(--border)', backgroundColor: 'var(--bg)', color: 'var(--text-primary)',
    fontSize: '15px', outline: 'none', transition: 'border-color 0.2s',
    boxSizing: 'border-box', fontFamily: 'inherit',
  };

  return (
        <section style={{ minHeight: '100vh', backgroundColor: 'var(--bg-page)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 24px 40px' }}>
          <div style={{ width: '100%', maxWidth: '420px' }}>
            <div style={{ textAlign: 'center', marginBottom: '36px' }}>
              <button onClick={() => navigateTo('company')} style={{ fontSize: '22px', fontWeight: 800, color: 'var(--text-primary)', background: 'none', border: 'none', cursor: 'pointer', marginBottom: '28px', display: 'inline-block' }}>
                Axigon<span style={{ color: 'var(--accent)' }}>AI</span>
              </button>
              <h2 style={{ fontSize: '26px', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '6px', letterSpacing: '-0.025em' }}>Welcome back</h2>
              <p style={{ color: 'var(--text-secondary)', fontSize: '14px', margin: 0, letterSpacing: '-0.005em' }}>Sign in to your Axigon AI account</p>
            </div>
            <div style={{ backgroundColor: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 'var(--radius-xl)', padding: '36px', boxShadow: 'var(--shadow-lg)' }}>
              {(error || notice) && (
                <div style={{ marginBottom: '20px', padding: '12px 16px', borderRadius: '8px', backgroundColor: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', color: '#EF4444', fontSize: '14px' }}>
                  {error || notice}
                </div>
              )}
              <SocialAuthButtons />
              <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: 500, color: 'var(--text-secondary)', marginBottom: '8px' }}>Email</label>
                  <input type="email" placeholder="you@company.com" value={loginData.email} onChange={e => setLoginData({ ...loginData, email: e.target.value })} disabled={loading}
                    style={inputStyle}
                    onFocus={e => e.currentTarget.style.borderColor = 'var(--accent)'}
                    onBlur={e => e.currentTarget.style.borderColor = 'var(--border)'}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: 500, color: 'var(--text-secondary)', marginBottom: '8px' }}>Password</label>
                  <input type="password" placeholder="Enter password" value={loginData.password} onChange={e => setLoginData({ ...loginData, password: e.target.value })} disabled={loading}
                    style={inputStyle}
                    onFocus={e => e.currentTarget.style.borderColor = 'var(--accent)'}
                    onBlur={e => e.currentTarget.style.borderColor = 'var(--border)'}
                  />
                </div>
                <button type="submit" disabled={loading}
                  style={{ ...btnPrimary, padding: '13px', fontSize: '15px', width: '100%', opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                  onMouseEnter={e => { if (!loading) btnPrimaryHover(e); }}
                  onMouseLeave={e => { if (!loading) btnPrimaryLeave(e); }}
                >{loading ? 'Logging in...' : 'Log In'}</button>
                <p style={{ textAlign: 'center', fontSize: '14px', color: 'var(--text-secondary)', margin: 0 }}>
                  Don't have an account?{' '}
                  <button type="button" onClick={() => navigateTo('signup')} style={{ color: 'var(--accent)', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: '14px' }}>Sign up</button>
                </p>
              </form>
            </div>
          </div>
        </section>
  );
};

export default LoginPage;
